// rename filename from urlLocale to locale.
export const EN_HK = 'en-hk';
export const CH_HK = 'ch-hk';
export const ZH_HK = 'zh-hk';
export const CH_TW = 'ch-tw';
export const ZH_TW = 'zh-tw';
export const MS_MY = 'ms-my';
export const EN_MY = 'en-my';
export const CH_MY = 'ch-my';
export const ZH_MY = 'zh-my';
export const ID_ID = 'id-id';
export const EN_ID = 'en-id';
export const EN_SG = 'en-sg';
export const KO_KR = 'ko-kr';
export const JA_JP = 'ja-jp';
export const EN_TH = 'en-th';
export const TH_TH = 'th-th';
export const EN_AU = 'en-au';
export const EN_NZ = 'en-nz';
export const VI_VN = 'vi-vn';
export const TH = 'th';
export const TW = 'tw';
export const MY = 'my';
export const ID = 'id';
export const SG = 'sg';
export const KR = 'kr';
export const HK = 'hk';
export const JP = 'jp';
export const AU = 'au';
export const VN = 'vn';
export const NZ = 'nz';



// WEBPACK FOOTER //
// ./app/constants/urlLocale.js